(function () {
  var FRAME_TYPE_OPTION_NAME = 'Framed/unframed options';
  var FRAME_STYLE_OPTION_NAME = 'Frame style';
  var HIDDEN_CLASS = 'frame-type-hidden';

  function getWrapper(scope, optionName) {
    return scope.querySelector('[data-option-name="' + optionName + '"]');
  }

  function getSelectedValue(wrapper) {
    if (!wrapper) return null;
    var select = wrapper.querySelector('select');
    if (select) return select.value;
    var checkedRadio = wrapper.querySelector('input[type="radio"]:checked');
    return checkedRadio ? checkedRadio.value : null;
  }

  function setValue(wrapper, value) {
    if (!wrapper) return;
    var select = wrapper.querySelector('select');
    if (select) {
      if (select.value !== value) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }
    var radios = wrapper.querySelectorAll('input[type="radio"]');
    radios.forEach(function (radio) {
      var shouldCheck = radio.value === value;
      if (radio.checked !== shouldCheck) {
        radio.checked = shouldCheck;
        if (shouldCheck) radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  function deriveFrameType(frameStyleValue) {
    if (!frameStyleValue) return null;
    return frameStyleValue.trim().toLowerCase().indexOf('framed') === 0 ? 'Framed' : 'Unframed';
  }

  function syncAll() {
    document.querySelectorAll('variant-selects').forEach(function (scope) {
      var frameTypeWrapper = getWrapper(scope, FRAME_TYPE_OPTION_NAME);
      var frameStyleWrapper = getWrapper(scope, FRAME_STYLE_OPTION_NAME);
      if (!frameTypeWrapper || !frameStyleWrapper) return;

      frameTypeWrapper.classList.add(HIDDEN_CLASS);

      var targetValue = deriveFrameType(getSelectedValue(frameStyleWrapper));
      if (targetValue) setValue(frameTypeWrapper, targetValue);
    });
  }

  // Re-sync whenever the visible Frame style field changes
  document.addEventListener('change', function (event) {
    var wrapper = event.target.closest ? event.target.closest('[data-option-name="' + FRAME_STYLE_OPTION_NAME + '"]') : null;
    if (wrapper) syncAll();
  });

  // Re-sync if the theme re-renders the picker (e.g. after changing Size)
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      syncAll();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState !== 'loading') {
    syncAll();
  } else {
    document.addEventListener('DOMContentLoaded', syncAll);
  }
})();
